import { Link } from "react-router-dom";

const STATS = [
  { icon: "ri-film-line", value: "2000+", label: "影视资源" },
  { icon: "ri-refresh-line", value: "每日", label: "持续更新" },
  { icon: "ri-earth-line", value: "多地", label: "覆盖地区" },
  { icon: "ri-gift-line", value: "免费", label: "在线观看" },
];

export default function IntroStats() {
  return (
    <div className="bg-primary-900 rounded-lg p-5 md:p-6 h-full flex flex-col text-background-100">
      <span className="w-10 h-10 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center mb-4">
        <i className="ri-film-line text-lg"></i>
      </span>
      <h3 className="font-heading text-lg md:text-xl font-bold text-background-50">关于水母影视</h3>
      <p className="mt-2 text-sm leading-relaxed text-background-200">
        聚合电影、电视剧与综艺内容，提供剧情介绍、更新追踪与影视资讯，让你自在浏览、快速找到想看的内容。
      </p>

      <div className="mt-5 grid grid-cols-2 gap-3">
        {STATS.map((stat) => (
          <div key={stat.label} className="rounded-lg bg-background-50/10 p-3">
            <i className={`${stat.icon} text-accent-400`}></i>
            <p className="mt-1.5 font-heading text-lg font-bold text-background-50">{stat.value}</p>
            <p className="text-xs text-background-300">{stat.label}</p>
          </div>
        ))}
      </div>

      <Link
        to="/about"
        className="mt-5 inline-flex items-center justify-center gap-2 h-10 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
      >
        了解我们
        <i className="ri-arrow-right-line"></i>
      </Link>
    </div>
  );
}